export default __webpack_public_path__ + "static/media/NoteImageTablet.7dc1ee14.png";